<script setup lang="ts">
  import { Picture } from '@travelata-libs/ui-kit';
  import { computed } from 'vue';
  import { LeadBannerAvatarsSize } from './LeadBanner.types';
  import { DEFAULT_PHOTOS, DEFAULT_PHOTOS_MOBILE } from './lib';

  interface LeadBannerAvatarsProps {
    mobile: boolean;
    centered?: boolean;
    count?: number;
    size?: `${LeadBannerAvatarsSize}`;
  }

  const props = withDefaults(defineProps<LeadBannerAvatarsProps>(), {
    centered: false,
    count: DEFAULT_PHOTOS.length,
    size: LeadBannerAvatarsSize.M,
  });

  const photos = computed(() => (props.mobile ? DEFAULT_PHOTOS_MOBILE : DEFAULT_PHOTOS));
</script>

<template>
  <div
    :class="[
      'tl-lead-banner-avatars',
      `tl-lead-banner-avatars_size-${size}`,
      {
        'tl-lead-banner-avatars_centered': centered,
        'tl-lead-banner-avatars_mobile': mobile,
      },
    ]"
    data-test-id="lead-banner-avatars"
  >
    <div v-for="(photo, index) in photos.slice(0, count)" :key="index" class="tl-lead-banner-avatars__wrapper">
      <Picture
        :path="photo"
        :lazy="false"
        :extensions="[]"
        :high-resolution="false"
        class="tl-lead-banner-avatars__avatar"
      />
      <span class="tl-lead-banner-avatars__online-dot" />
    </div>
  </div>
</template>

<style lang="scss" scoped>
  .tl-lead-banner-avatars {
    $root: &;

    align-items: center;
    display: flex;

    &_centered {
      justify-content: center;
    }

    &_size-m {
      #{$root}__avatar {
        height: 56px;
        width: 56px;
      }
    }

    &_size-l {
      #{$root}__avatar {
        height: 60px;
        width: 60px;
      }
    }

    &_mobile {
      #{$root}__avatar {
        height: 44px;
        width: 44px;
      }
    }

    &__wrapper {
      margin-left: -13px;
      position: relative;

      &:first-child {
        margin-left: 0;
      }

      #{$root}_mobile & {
        margin-left: -12.1px;
      }
    }

    &__avatar {
      border-radius: 50%;
      box-shadow: var(--shadow-s);
      object-fit: cover;
      outline: 2px solid var(--color-bg-primary);

      #{$root}_mobile & {
        outline: 1.5px solid var(--color-bg-primary);
      }
    }

    &__online-dot {
      background-color: var(--color-green-50);
      border: 2px solid var(--color-bg-primary);
      border-radius: 50%;
      bottom: 0;
      height: 10px;
      left: 24%;
      position: absolute;
      transform: translateX(-50%);
      width: 10px;

      #{$root}_mobile & {
        border: 1.5px solid var(--color-bg-primary);
        height: 8px;
        width: 8px;
      }
    }
  }
</style>
